<template>
    <v-container v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
        <v-row>
            <v-col cols="12" sm="12" md="4" lg="4" class="d-flex justify-center align-center flex-column">
                <scorsync-avatar :person="athlete" size="lg" />
            </v-col>

            <v-col cols="12" sm="12" md="8" lg="8" class="d-flex justify-center text-center">
                <athlete-header :athlete-id="athlete.id" @switch-tab="currentTab = $event" />
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8">
                <athlete-results
                    :athlete-id="athlete.id"
                    :qualification="athleteQualification"
                    :tab.sync="currentTab"
                    @switch-tab="currentTab = $event"
                />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
                <athlete-stats :athlete-id="athlete.id" />
            </v-col>
        </v-row>
    </v-container>

    <v-container v-else>
        <v-row>
            <v-col cols="12" sm="12" md="4" lg="4">
                <div class="d-flex justify-center align-center flex-column">
                    <scorsync-avatar :person="athlete" size="lg" />
                </div>

                <athlete-stats :athlete-id="athlete.id" />
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8">
                <athlete-header :athlete-id="athlete.id" @switch-tab="currentTab = $event" />

                <athlete-results
                    :athlete-id="athlete.id"
                    :qualification="athleteQualification"
                    :tab.sync="currentTab"
                    @switch-tab="currentTab = $event"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ScorsyncAvatar from '@/Components/ScorsyncAvatar.vue';
import AthleteStats from '@/Components/AthleteStats.vue';
import AthleteResults from '@/Components/AthleteResults.vue';
import Athlete from '@/Models/Athlete.js';
import AthleteHeader from '@/Components/AthleteHeader.vue';
import User from '@/Models/User.js';
import PageMixin from '@/Pages/Page.mixin.js';

export default {
    name: 'Athlete',

    components: {
        AthleteHeader,
        AthleteResults,
        AthleteStats,
        ScorsyncAvatar,
    },

    mixins: [PageMixin],

    props: {
        athleteId: {
            type: Number,
            required: true,
        },

        athleteQualification: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },

    data: () => ({
        currentTab: 'tab-results',
    }),

    computed: {
        athlete() {
            return Athlete.query()
                .with(['results.meet', 'results.category', 'club'])
                .with('results', (query) => {
                    if (this.filterEvent) {
                        query.where('event', this.filterEvent);
                    }
                })
                .find(this.athleteId);
        },

        user() {
            if (!this.$page.props.auth.user) {
                return null;
            }

            return User.query().with('affiliations').find(this.$page.props.auth.user.id);
        },

        meets() {
            const allMeets = _.map(this.athlete.results, 'meet');

            return _.uniqBy(allMeets, 'id');
        },
    },

    async created() {
        if (this.$page.props.auth.user) {
            await User.insert({ data: this.$page.props.auth.user });
        }
    },
};
</script>
